<template>
    <div class="modal modal-sheet position-static d-block bg-body-first p-4 py-md-5" tabindex="-1" role="dialog"
        id="modalSignin">
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-4 shadow">
                <div class="modal-header p-5 pb-4 border-bottom-0">
                    <h1 class="fw-bold mb-0 fs-2">Регистрация в системе</h1>
                </div>
                <div class="modal-body p-5 pt-0">
                    <div v-if="this.error" class="alert alert-danger" role="alert">
                            {{ msg }}
                    </div>
                    <form action="" method="POST">
                        <div class="form-floating mb-3">
                            <input
                                :class="'form-control rounded-3 ' + (!!~invalid.indexOf('login') ? 'is-invalid' : '')"
                                ref="login" name="login" required="" type="text" placeholder="">
                            <label for="floatingInput">Логин</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите логин
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input
                                :class="'form-control rounded-3 ' + (!!~invalid.indexOf('password') ? 'is-invalid' : '')"
                                ref="password" name="password" required="" type="password" placeholder=""> 
                            <label for="floatingPassword">Пароль</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите пароль
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input
                                :class="'form-control rounded-3 ' + (!!~invalid.indexOf('email') ? 'is-invalid' : '')"
                                ref="email" name="email" required="" type="text" placeholder="">
                            <label for="floatingEmail">Электронная почта</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите электронную почту
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input :class="'form-control rounded-3 ' + (!!~invalid.indexOf('name') ? 'is-invalid' : '')"
                                ref="name" name="name" required="" type="text" placeholder="">
                            <label for="floatingName">Имя</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите имя
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input
                                :class="'form-control rounded-3 ' + (!!~invalid.indexOf('surname') ? 'is-invalid' : '')"
                                ref="surname" name="surname" required="" type="text" placeholder="">
                            <label for="floatingSurname">Фамилия</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите фамилию
                            </div>
                        </div>
                        <div class="form-floating mb-3">
                            <input
                                :class="'form-control rounded-3 ' + (!!~invalid.indexOf('phone') ? 'is-invalid' : '')"
                                ref="phone" name="phone" required="" type="text" placeholder="">
                            <label for="floatingPhone">Телефон</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите телефон
                            </div>
                        </div>
                        <button @click="VerifyClbk" class="w-100 mb-2 btn btn-lg rounded-3 btn-secondary" name="verify"
                            id="submit" type="button">Выслать код</button>
                        <div v-if="verify" class="form-floating mb-3">
                            <input :class="'form-control rounded-3 ' + (!!~invalid.indexOf('code') ? 'is-invalid' : '')"
                                ref="code" required="" type="text" value="">
                            <label for="floatingCode">Код подтверждения</label>
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Введите код
                            </div>
                        </div>
                        <button @click.prevent="RegClbk" v-if="verify"
                            class="w-100 mb-2 btn btn-lg rounded-3 btn-primary" name="submit" id="submit"
                            type="submit">Зарегистрироваться</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const sha256 = require("js-sha256").sha256

export default {
    name: 'RegForm',
    data() {
        return {
            verify: false,
            invalid: [],
            error: false,
            msg: ''
        }
    },
    methods: {
        VerifyClbk() {
            const login = this.$refs.login.value
            const pass = this.$refs.password.value
            const name = this.$refs.name.value
            const surn = this.$refs.surname.value
            const phone = this.$refs.phone.value
            const email = String(this.$refs.email.value)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                )
            this.invalid = []
            if (login == '') {
                this.invalid.push('login')
            }
            if (pass == '') {
                this.invalid.push('password')
            }
            if (name == '') {
                this.invalid.push('name')
            }
            if (surn == '') {
                this.invalid.push('surname')
            }
            if (phone == '') {
                this.invalid.push('phone')
            }
            if (email == null) {
                this.invalid.push('email')
            }
            if (this.invalid.length > 0) {
                return
            }
            fetch("https://api.bormart.ru/verify", {
                method: "POST",
                headers: {
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    "email": email
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 2) {
                    this.verify = true
                } else if (data['ok'] == 0) {
                    switch (data['cause']) {
                        case 'Code not be able to send':
                            this.error = true;
                            this.msg = "Код подтверждения не может быть отправлен! Обратитесь к администрации сайта!"
                            break;
                    }
                }
            })
        },
        RegClbk() {
            this.error = false
            this.msg = ''
            fetch("https://api.bormart.ru/verify", {
                method: "POST",
                headers: {
                    "Content-type": "application/json"
                },
                body: JSON.stringify({
                    "email": this.$refs.email.value,
                    "login": this.$refs.login.value,
                    "password": sha256(this.$refs.password.value),
                    "name": this.$refs.name.value,
                    "surname": this.$refs.surname.value,
                    "phone": this.$refs.phone.value,
                    "code": this.$refs.code.value,
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data['ok'] == 1) {
                    this.$emit("RegOk")
                } else if (data['ok'] == 0) {
                    this.error = true
                    window.location = '#'
                    this.verify = false
                    switch (data['cause']) {
                        case 'Wrong code':
                            this.msg = "Неверный код!"
                            break;
                        case 'Already exists':
                            this.msg = "Такой пользователь уже существует!"
                            break;
                    }
                }
            })
        }
    }
}
</script>